import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "live-withdraws" }
const _hoisted_2 = { class: "withdraws-header" }
const _hoisted_3 = { class: "header-text" }
const _hoisted_4 = { class: "text-top" }
const _hoisted_5 = { class: "text-bottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Item = _resolveComponent("Item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createStaticVNode("<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" class=\"header-icon\" data-v-7fa79612><g opacity=\"0.5\" data-v-7fa79612><path d=\"M12 21V12\" stroke=\"#A2A3AC\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-7fa79612></path><path d=\"M10 19L12 21L14 19\" stroke=\"#A2A3AC\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-7fa79612></path><path d=\"M3 8H21\" stroke=\"#A2A3AC\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-7fa79612></path><path d=\"M8 16H6C4.343 16 3 14.657 3 13V6C3 4.343 4.343 3 6 3H18C19.657 3 21 4.343 21 6V13C21 14.657 19.657 16 18 16H16\" stroke=\"#A2A3AC\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-7fa79612></path></g></svg>", 1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.t('LiveWithdraws.title')), 1),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.t('LiveWithdraws.total', [_ctx.totalNormalized])), 1)
      ])
    ]),
    _createVNode(_TransitionGroup, {
      tag: "div",
      class: "withdraws-items",
      name: _ctx.transitions ? 'withdraw' : 'v',
      duration: 500
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.withdraws, (withdraw) => {
          return (_openBlock(), _createBlock(_component_Item, {
            key: withdraw.id,
            id: withdraw.id,
            method: !!withdraw.method,
            icon: withdraw.method ? withdraw.method.imageUrl : withdraw.item.icon,
            amount: withdraw.amountUsd,
            userID: withdraw.user.id,
            avatar: withdraw.user.avatar,
            name: withdraw.user.name
          }, null, 8, ["id", "method", "icon", "amount", "userID", "avatar", "name"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["name"])
  ]))
}